@use '~/theme/theme' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: spacing(3);
  height: 100%;
  overflow: hidden;
}

.searchResults {
  display: flex;
  flex-direction: column;
  gap: spacing(2);
  overflow: auto;
  padding: 0 spacing(3);
  max-height: 400px;
}

.emptyState {
  padding: spacing(3.5);
}
